// Unified click tracking helper.
// Fires events on the analytics tools that may be present in the page:
//   - GTM (window.dataLayer)
//   - GA4 (window.gtag)
//   - Meta Pixel (window.fbq)
// If none are installed the helper is a no-op (safe to call always).
//
// Usage:
//   import { trackWaClick } from "@/lib/track";
//   <a onClick={() => trackWaClick("hero_main")} href={waUrl}>...</a>

const isClient = typeof window !== "undefined";

const safeCall = (fn) => {
  try { fn(); } catch (_) { /* swallow analytics errors */ }
};

export const track = (eventName, params = {}) => {
  if (!isClient) return;
  const payload = { event: eventName, ...params };

  // GTM dataLayer
  if (Array.isArray(window.dataLayer)) {
    safeCall(() => window.dataLayer.push(payload));
  }

  // GA4
  if (typeof window.gtag === "function") {
    safeCall(() => window.gtag("event", eventName, params));
  }

  // Meta Pixel — map common events to Pixel taxonomy
  if (typeof window.fbq === "function") {
    if (eventName === "whatsapp_click") {
      safeCall(() => window.fbq("trackCustom", "WhatsAppClick", params));
    } else if (eventName === "lead") {
      safeCall(() => window.fbq("track", "Lead", params));
    } else {
      safeCall(() => window.fbq("trackCustom", eventName, params));
    }
  }
};

// Convenience helper specifically for WhatsApp CTAs.
// `source` identifies the surface (hero_main, line_misiones, event_fitur, etc.)
// `label` (optional) is human-readable detail (event name, line title, etc.)
export const trackWaClick = (source, label) => {
  track("whatsapp_click", {
    cta: "whatsapp",
    source,
    label: label || source,
    page: isClient ? window.location.pathname : "/",
  });
  // Also fire a generic Lead event for Pixel conversion APIs
  track("lead", { source, label: label || source });
};
